import { CriteriaInterface } from '../interfaces/criteria.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('CriteriaResponse')
export class CriteriaResponse implements CriteriaInterface {
  @JsonProperty('Code', String, true)
  code: string = undefined;

  @JsonProperty('Id', Number, true)
  id: number = undefined;

  @JsonProperty('Name', String, true)
  name: string = undefined;

  @JsonProperty('TextValue', String, true)
  textValue: string = undefined;

  @JsonProperty('Value', String, true)
  value: string = undefined;
}
